import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';

import { actions } from '../../../state/filterActions';

import type { OverrideValues, PaleState } from '../../../interfaces';
import { RangeSlider, type RangeSliderDispatchProps, type RangeSliderStateProps } from './RangeSlider';

type OwnProps = Pick<RangeSliderDispatchProps, 'triggerFetch'>;

export const mapStateToProps = (state: PaleState): RangeSliderStateProps => ({
    id: 'DurationSlider',
    label: 'Reiselengde',
    min: 2,
    max: 35,
    stepSize: 1,
    initialValues: state.filters.duration,
    resetOnDefault: false,
    metric: 'dager',
});

export const mapDispatchToProps: OverrideValues<RangeSliderDispatchProps, ActionCreator<unknown>> = {
    onChange: actions.changeDuration,
};

export default connect<RangeSliderStateProps, RangeSliderDispatchProps, OwnProps, PaleState>(
    mapStateToProps,
    mapDispatchToProps
)(RangeSlider);
